import { EventScheduler } from '../../../../utils/EventScheduler';
import type { BoardScheduler } from '../../types';

export class NoViewScheduler implements BoardScheduler {
  private readonly scheduler: EventScheduler = new EventScheduler();

  private currentTime = 0;

  public wait(_: string, delay: number): Promise<void> {
    return this.scheduler.wait(delay);
  }

  public *waitGenerator(_: string, delay: number): Generator<void, void> {
    const targetTime = this.currentTime + delay;
    while (this.currentTime < targetTime) {
      yield;
    }
  }

  public update(deltaTime: number): void {
    this.scheduler.update(deltaTime);
    this.currentTime += (deltaTime * 1000) / 60;
  }
}
